import { offers } from '../../../mocks/offersData';

export default function Offers() {
  return (
    <section id="ofertas" className="py-24 px-6 lg:px-20 bg-[#E63946]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-white/20 px-4 py-2 rounded-full mb-6">
            <p className="text-white font-semibold text-sm">OFERTAS ESPECIALES</p>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-4">
            Menús y <span className="text-white">Promociones</span>
          </h2>
          <p className="text-xl text-white/90">Perfectos para compartir en familia</p>
        </div>

        {/* Offers Grid */}
        <div className="grid lg:grid-cols-3 gap-8 mb-8">
          {offers.slice(0, 3).map((offer, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl p-8 text-gray-900 shadow-2xl hover:scale-105 transition-all ${
                index === 1 ? 'lg:-translate-y-5' : ''
              }`}
              style={{ transform: index === 0 ? 'rotate(-1deg)' : index === 2 ? 'rotate(1deg)' : '' }}
            >
              {/* Badge */}
              {offer.badge && (
                <div className="inline-block bg-[#E63946] px-4 py-2 rounded-full mb-4">
                  <p className="text-sm font-bold text-white">{offer.badge}</p>
                </div>
              )}

              {/* Icon */}
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${offer.icon} text-4xl text-gray-900`}></i>
              </div>

              {/* Content */}
              <h3 className="text-3xl font-bold mb-4 text-gray-900">{offer.title}</h3>
              <p className="text-lg mb-6 text-gray-700 leading-relaxed">{offer.description}</p>

              {/* Items */}
              <ul className="space-y-2 mb-6">
                {offer.items.map((item, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-gray-900">
                    <i className="ri-check-line text-xl text-[#E63946]"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              {/* Price */}
              <div className="flex items-end justify-between pt-6 border-t border-gray-200">
                <span className="text-sm font-semibold text-gray-700">Desde</span>
                <span className="text-4xl font-extrabold text-gray-900">{offer.price}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Second Row - 2 Cards */}
        <div className="grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {offers.slice(3, 5).map((offer, index) => (
            <div
              key={index + 3}
              className="bg-white rounded-3xl p-8 text-gray-900 shadow-2xl hover:scale-105 transition-all"
            >
              {/* Badge */}
              {offer.badge && (
                <div className="inline-block bg-[#E63946] px-4 py-2 rounded-full mb-4">
                  <p className="text-sm font-bold text-white">{offer.badge}</p>
                </div>
              )}

              {/* Icon */}
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${offer.icon} text-4xl text-gray-900`}></i>
              </div>

              {/* Content */}
              <h3 className="text-3xl font-bold mb-4 text-gray-900">{offer.title}</h3>
              <p className="text-lg mb-6 text-gray-700 leading-relaxed">{offer.description}</p>

              {/* Items */}
              <ul className="space-y-2 mb-6">
                {offer.items.map((item, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-gray-900">
                    <i className="ri-check-line text-xl text-[#E63946]"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              {/* Price */}
              <div className="flex items-end justify-between pt-6 border-t border-gray-200">
                <span className="text-sm font-semibold text-gray-700">Desde</span>
                <span className="text-4xl font-extrabold text-gray-900">{offer.price}</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 bg-white/10 backdrop-blur-sm rounded-[40px] p-16 text-center">
          <h3 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            ¿Tienes hambre?
          </h3>
          <p className="text-2xl text-white mb-2">
            Llámanos ahora y
          </p>
          <p className="text-2xl italic text-white font-semibold mb-8">
            recibe tu pedido en minutos
          </p>
          <a
            href="tel:919123048"
            className="inline-flex items-center gap-3 bg-gray-900 text-white px-16 py-5 rounded-full text-2xl font-bold hover:bg-gray-800 transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            919 123 048
          </a>
        </div>
      </div>
    </section>
  );
}
